import { createAction } from '@reduxjs/toolkit';

export const BookActions = {
  getMyBooks: createAction<{ loading?: boolean }>('user/GET_MY_BOOKS'),
  updateCoverThumbnail: createAction<{ bookId: string; pageId: string }>('user/UPDATE_COVER_THUMBNAIL'),
};
